// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","Content":"Footer_Content__-mqKN","Link":"Footer_Link__abupq","Dot":"Footer_Dot__SkfyL","Text":"Footer_Text__U0jgw","Image":"Footer_Image__t7DFZ"};